import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=2ea64fd5"
import script from "./AlertPopup.vue?vue&type=script&lang=ts"
export * from "./AlertPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports